import { render, staticRenderFns } from "./ExamsDetail.vue?vue&type=template&id=b4e9ab10&"
import script from "./ExamsDetail.vue?vue&type=script&lang=js&"
export * from "./ExamsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports